import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { InputMultiSelectComponent } from './input-multi-select.component';

@NgModule({
  declarations: [InputMultiSelectComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
  ],
  exports: [InputMultiSelectComponent],
})
export class InputMultiSelectModule {}
